module.exports = __webpack_public_path__ + "img/il-search-results-not-found.cbf74f7.svg";